var url;
if (process.env.REACT_APP_QA === "qa") {
  url = "https://airtouch.hyperether.com";
} else if (process.env.REACT_APP_PROD === "prod") {
  url = "";
} else if (process.env.REACT_APP_STAGING === "staging") {
  url = "https://airtouch-prod.hyperether.com";
} else if (process.env.REACT_APP_DEV === "dev") {
  url = "http://localhost:3000";
} else if (process.env.NODE_ENV === "development") {
  console.log("development");
  url = "http://localhost:3000";
} else {
  url = "http://localhost:3000";
}
export default url;



// WEBPACK FOOTER //
// ./src/environment.js